<script lang="ts" setup>
const { tvBonusPackagesInCart, tvPackagesInCart, tvExtrasInCart } =
  await useCart()

const { addNotification } = useNotifications()

function _addPackageNotification() {
  addNotification({
    title: 'Balíček byl přidán do košíku',
    time: 3000,
  })
}

const { planPackages, channelsByPackages, chosenPackage, fetchChannels } =
  useTvChannels()

await useLazyAsyncData(() => fetchChannels())

const addedToCartDialogOpen = ref(false)
</script>

<template>
  <main>
    <UiBanner
      image="/img/grape_pozadi_televize.jpg"
      class="flex items-center justify-center py-32"
    >
      <div
        class="container mx-auto flex w-fit items-end justify-center max-sm:flex-col sm:items-start"
      >
        <UiBannerTitle class="col-span-2 max-w-xl !text-left">
          UŽÍVEJTE SI
          <span class="block font-light">
            NEZAPOMENUTELNÉ CHVÍLE S GENIUS TV
          </span>
        </UiBannerTitle>
        <div class="w-fit">
          <img class="max-h-60 sm:max-h-96" src="/img/Grapik_televize.png" />
        </div>
      </div>
    </UiBanner>
    <UiSection
      title="Vyberte si službu, která Vám vyhovuje"
      class="bg-[url(/img/grape_pozadi_sede.png)] bg-cover"
    >
      <div class="mx-auto grid w-fit grid-cols-1 gap-5 lg:grid-cols-3">
        <UiCard
          v-for="(planPackage, index) in planPackages"
          :key="index"
          icon="ikona_tv"
        >
          <UiCardTitle class="uppercase">{{ planPackage.title }}</UiCardTitle>
          <UiCardBanner class="flex-col">
            <p class="font-medium">{{ planPackage.channelsCount }} programů</p>
            <p class="text-lg">
              více než {{ planPackage.hdChannelsCount }} v HD kvalitě
            </p>
          </UiCardBanner>
          <div class="mx-auto my-10 max-h-60 w-fit">
            <img class="h-full max-h-60 w-auto" :src="planPackage.image" />
          </div>
          <UiCardBanner
            v-for="(banner, bannerIndex) in planPackage.banners"
            :key="bannerIndex"
            :type="banner.type"
            class="flex items-center justify-between"
          >
            <img :src="'/img/' + banner.icon + '.svg'" class="size-10" />
            <div class="text-lg font-normal">
              <p v-for="(text, textIndex) in banner.title" :key="textIndex">
                {{ text }}
              </p>
            </div>
          </UiCardBanner>
          <UiCardBanner
            type="red"
            class="flex items-center justify-center !font-bold"
          >
            {{ planPackage.price }} Kč
          </UiCardBanner>
          <div class="my-4">
            <UiDialog>
              <template #default="{ close }">
                <button class="ml-auto block" @click="close">
                  <Icon name="fa6-solid:xmark" class="size-8"></Icon>
                </button>
                <div
                  class="mx-auto flex w-fit flex-wrap items-center justify-center gap-5"
                >
                  <template
                    v-for="channel in planPackage.channels?.sort(sortChannels)"
                    :key="channel.id"
                  >
                    <UiTooltip :label="channel.nazev">
                      <template #activator>
                        <div class="w-16">
                          <img height="96" :src="channel?.logo ?? undefined" />
                        </div>
                      </template>
                      <template #default>
                        <div class="m-2 flex flex-col gap-2">
                          <p class="text-xl font-bold">{{ channel.nazev }}</p>
                          <p class="text-sm">{{ channel.popis }}</p>
                        </div>
                      </template>
                    </UiTooltip>
                  </template>
                </div>
                <table
                  v-if="false"
                  class="mx-auto rounded-3xl border border-neutral-200"
                >
                  <tbody>
                    <tr class="font-bold">
                      <td class="py-4">Název</td>
                      <td class="py-4">Kategorie</td>
                      <td class="py-4">Popis</td>
                      <td class="py-4">Kvalita</td>
                      <td class="py-4">Multiscreen</td>
                    </tr>

                    <tr
                      v-for="channel in planPackage.channels?.sort(
                        sortChannels
                      )"
                      :key="channel.id"
                      class="even:bg-neutral-50"
                    >
                      <td class="pr-2">{{ channel.nazev }}</td>
                      <td class="pr-2">{{ channel.kategorie }}</td>
                      <td class="max-w-xl py-2 pr-2">
                        {{ channel.popis }}
                      </td>
                      <td class="pr-2">{{ channel.kvalita }}</td>
                      <td class="pr-2">
                        <div class="mx-auto w-fit">
                          <Icon
                            v-if="channel.is_multiscreen"
                            class="text-green-500"
                            name="fa6-solid:check"
                          />
                          <Icon
                            v-else
                            class="text-red-500"
                            name="fa6-solid:xmark"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template #activator="{ open }">
                <button
                  class="w-full rounded-full bg-neutral-700 px-4 py-2 font-medium text-white"
                  @click="open"
                >
                  PROGRAMOVÁ SKLADBA BALÍČKU
                </button>
              </template>
            </UiDialog>
          </div>
          <div>
            <Platforms />
          </div>
          <div class="mt-5">
            <div class="flex flex-col items-center justify-center gap-2">
              <UiDialog class="w-fit p-8">
                <template #activator="{ open }">
                  <button
                    class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"
                    @click="
                      () => {
                        tvPackagesInCart.push(index)
                        open()
                      }
                    "
                  >
                    Přidat do košíku
                  </button>
                </template>
                <template #default="{ close }">
                  <div class="text-center">
                    <p class="mb-8 text-2xl font-bold">
                      Balíček byl přidán do košíku
                    </p>
                    <div class="flex justify-center gap-2">
                      <UiButton @click="close">Pokračovat v nákupu</UiButton>
                      <NuxtLink to="/kosik">
                        <UiButton>Košík</UiButton>
                      </NuxtLink>
                    </div>
                  </div>
                </template>
              </UiDialog>
              <UiButtonPhone class="px-8 py-2 text-base" />
            </div>
          </div>
        </UiCard>
      </div>
    </UiSection>
    <UiSection
      title="Přídavné prémiové balíčky programů"
      class="bg-[url(/img/grape_pozadi_sede.png)] bg-cover"
    >
      <UiCard class="mb-5 pb-0" icon="ikona_balicky">
        <div class="flex w-full justify-around overflow-auto pb-5">
          <button
            v-for="pckg in bonusPackages"
            :key="pckg.id"
            class="text-nowrap px-5 pt-4 text-center"
            :class="
              chosenPackage === pckg.id
                ? '-mb-5 rounded-t-xl bg-sky-600 pb-5 text-white'
                : ''
            "
            @click="chosenPackage = pckg.id"
          >
            <p
              class="text-2xl font-semibold text-sky-600"
              :class="chosenPackage === pckg.id ? 'text-white' : ''"
            >
              {{ pckg.title }}
            </p>
            <p class="font-medium">{{ pckg.price }} Kč / měs.</p>
          </button>
        </div>
      </UiCard>
      <UiCard class="mb-5">
        <template v-for="(channels, index) in channelsByPackages" :key="index">
          <div v-if="chosenPackage === index">
            <div
              class="mx-auto mb-5 flex w-fit flex-wrap items-center justify-center gap-5"
            >
              <div v-for="channel in channels" :key="channel.id" class="w-24">
                <UiTooltip :label="channel.nazev">
                  <template #activator>
                    <img height="96" :src="channel.logo ?? undefined" />
                  </template>
                  <template #default>
                    <div class="m-2 flex flex-col gap-2">
                      <p class="text-xl font-bold">{{ channel.nazev }}</p>
                      <p class="text-sm">{{ channel.popis }}</p>
                    </div>
                  </template>
                </UiTooltip>
              </div>
            </div>
            <UiDialog class="w-fit p-8">
              <template #activator="{ open }">
                <UiButton
                  class="mx-auto block"
                  @click="
                    () => {
                      tvBonusPackagesInCart.push(chosenPackage)
                      open()
                    }
                  "
                >
                  Přidat do košíku
                </UiButton>
              </template>
              <template #default="{ close }">
                <div class="text-center">
                  <p class="mb-8 text-2xl font-bold">
                    Balíček byl přidán do košíku
                  </p>
                  <div class="flex justify-center gap-2">
                    <UiButton @click="close">Pokračovat v nákupu</UiButton>
                    <NuxtLink to="/kosik">
                      <UiButton>Košík</UiButton>
                    </NuxtLink>
                  </div>
                </div>
              </template>
            </UiDialog>
          </div>
        </template>
      </UiCard>
    </UiSection>
    <UiSection
      title="Kolik Vás bude rozšíření služeb stát?"
      class="bg-[url(/img/grape_pozadi_sede.png)] bg-cover"
    >
      <div
        class="grid justify-items-stretch gap-5 sm:grid-cols-2 lg:grid-cols-3"
      >
        <UiCard
          icon="ikona_mobilni_zarizeni"
          class="flex flex-col justify-between"
        >
          <div>
            <UiCardTitle>Mobilní zařízení</UiCardTitle>
            <div class="mx-auto max-w-60 text-center">
              <p class="mb-5">Sledujte TV na Vašem mobilním zařížení či v PC</p>
              <p class="mb-5">Automaticky ZDARMA</p>
            </div>
          </div>
          <UiCardBanner
            type="red"
            class="mb-[60px] flex items-center justify-center !font-bold"
          >
            0 Kč
          </UiCardBanner>
        </UiCard>
        <UiCard icon="ikona_pretaceni" class="flex flex-col justify-between">
          <div>
            <UiCardTitle>Zpětné přetáčení 14</UiCardTitle>
            <div class="mx-auto max-w-60 text-center">
              <p class="mb-5">
                Rozšiřte si možnost zpětného přetáčení ze 7 dnů až na 14 dní
              </p>
              <p class="mb-5">
                Sledujte tak své pořady v naprosté volnosti, kdy Vy chcete!
              </p>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <UiCardBanner
              type="red"
              class="flex items-center justify-center !font-bold"
            >
              25 Kč
            </UiCardBanner>
            <button
              class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"
              @click="
                () => {
                  tvExtrasInCart.push({
                    title: 'Zpětné přetáčení 14',
                    price: 25,
                  })
                  addedToCartDialogOpen = true
                }
              "
            >
              Přidat do košíku
            </button>
          </div>
        </UiCard>
        <!--                                     HIDE FOR NOW        -->
        <!--        <UiCard-->
        <!--          material-icon="material-symbols:ad-off"-->
        <!--          class="flex flex-col justify-between"-->
        <!--        >-->
        <!--          <div>-->
        <!--            <UiCardTitle>PRIMA bez reklam</UiCardTitle>-->
        <!--            <div class="mx-auto max-w-60 text-center">-->
        <!--              <p class="mb-5">Sledujte kanály TV Prima bez reklamních bloků</p>-->
        <!--              <p class="mb-5">-->
        <!--                Systém reklamy automaticky znepřístupní bez Vašeho zásahu.-->
        <!--                Otázky a odpovědi k přetáčení zde. Aktivujte na webu geniustv-->
        <!--                dle návodu.-->
        <!--              </p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="flex flex-col gap-5">-->
        <!--            <UiCardBanner-->
        <!--              type="red"-->
        <!--              class="flex items-center justify-center !font-bold"-->
        <!--            >-->
        <!--              79 Kč-->
        <!--            </UiCardBanner>-->
        <!--            <button-->
        <!--              @click="-->
        <!--                () => {-->
        <!--                  tvExtrasInCart.push({ title: 'PRIMA bez reklam', price: 79 })-->
        <!--                  addedToCartDialogOpen = true-->
        <!--                }-->
        <!--              "-->
        <!--              class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"-->
        <!--            >-->
        <!--              Přidat do košíku-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </UiCard>-->
        <UiCard icon="ikona_nahravani" class="flex flex-col justify-between">
          <div>
            <UiCardTitle>Nahrávání 25</UiCardTitle>
            <div class="mx-auto max-w-72 text-center">
              <p class="mb-5">
                Nahrajte si své oblíbené TV pořady. Dokonce i ty, které již TV
                odvysílala!
              </p>
              <p class="mb-5">
                Celková doba nahrávek je
                <span class="font-bold">25 hodin</span>
                . Pořady jsou uloženy po dobu 3 měsíců.
              </p>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <UiCardBanner
              type="red"
              class="flex items-center justify-center !font-bold"
            >
              25 Kč
            </UiCardBanner>
            <button
              class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"
              @click="
                () => {
                  tvExtrasInCart.push({ title: 'Nahrávání 25', price: 25 })
                  addedToCartDialogOpen = true
                }
              "
            >
              Přidat do košíku
            </button>
          </div>
        </UiCard>
        <UiCard icon="ikona_nahravani" class="flex flex-col justify-between">
          <div>
            <UiCardTitle>Nahrávání 50</UiCardTitle>
            <div class="mx-auto max-w-72 text-center">
              <p class="mb-5">
                Nahrajte si své oblíbené TV pořady. Dokonce i ty, které již TV
                odvysílala!
              </p>
              <p class="mb-5">
                Celková doba nahrávek je
                <span class="font-bold">50 hodin</span>
                . Pořady jsou uloženy po dobu 6 měsíců.
              </p>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <UiCardBanner
              type="red"
              class="flex items-center justify-center !font-bold"
            >
              50 Kč
            </UiCardBanner>
            <button
              class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"
              @click="
                () => {
                  tvExtrasInCart.push({ title: 'Nahrávání 50', price: 50 })
                  addedToCartDialogOpen = true
                }
              "
            >
              Přidat do košíku
            </button>
          </div>
        </UiCard>
        <UiCard icon="ikona_nahravani" class="flex flex-col justify-between">
          <div>
            <UiCardTitle>Nahrávání 100</UiCardTitle>
            <div class="mx-auto max-w-72 text-center">
              <p class="mb-5">
                Nahrajte si své oblíbené TV pořady. Dokonce i ty, které již TV
                odvysílala!
              </p>
              <p class="mb-5">
                Celková doba nahrávek je
                <span class="font-bold">100 hodin</span>
                . Pořady jsou uloženy po dobu 6 měsíců.
              </p>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <UiCardBanner
              type="red"
              class="flex items-center justify-center !font-bold"
            >
              100 Kč
            </UiCardBanner>
            <button
              class="rounded-full bg-sky-600 px-8 py-2 font-medium text-white"
              @click="
                () => {
                  tvExtrasInCart.push({ title: 'Nahrávání 100', price: 100 })
                  addedToCartDialogOpen = true
                }
              "
            >
              Přidat do košíku
            </button>
          </div>
        </UiCard>
      </div>
      <UiDialog v-model="addedToCartDialogOpen" class="w-fit p-8">
        <template #activator>
          <div></div>
        </template>
        <template #default="{ close }">
          <div class="text-center">
            <p class="mb-8 text-2xl font-bold">Balíček byl přidán do košíku</p>
            <div class="flex justify-center gap-2">
              <UiButton @click="close">Pokračovat v nákupu</UiButton>
              <NuxtLink to="/kosik">
                <UiButton>Košík</UiButton>
              </NuxtLink>
            </div>
          </div>
        </template>
      </UiDialog>
    </UiSection>
    <CTASection
      image="/img/Grapik_telefon2.png"
      class="bg-[url(/img/grape_pozadi_cervene.png)] bg-cover"
    >
      <div class="flex justify-end gap-8">
        <img src="/img/ikona_vylepseni.svg" class="size-20" />
        <div>
          <h2 class="text-3xl font-bold text-neutral-700">Vylepšete si</h2>
          <h2 class="mb-10 text-3xl font-bold text-neutral-700">
            stávající služby
          </h2>
        </div>
      </div>
      <p class="mb-10 text-2xl font-thin">
        Rozšiřte si své služby televizního vysílání a užijte si neomezené
        možnosti zábavy. Úpravou stávajících služeb získáte více času na zpětné
        přetáčení oblíbených pořadů, sledování televizních kanálů bez reklam a
        možnost nahrávat až 100 hodin svých oblíbených programů, včetně
        sledování na mobilních zařízeních a počítačích.
      </p>
    </CTASection>
  </main>
</template>
